import { render, staticRenderFns } from "./VehicleExtras.vue?vue&type=template&id=161c52de&"
import script from "./VehicleExtras.vue?vue&type=script&lang=js&"
export * from "./VehicleExtras.vue?vue&type=script&lang=js&"
import style0 from "./VehicleExtras.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports